/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-undef */
import * as auth0 from "auth0-js";
import { Dispatch } from "redux";
import * as actionTypes from "./actionTypes";
import TypeKeys, { AuthAction } from "./actionTypes";
import * as constants from "./constants";
import { storage } from "./utils/index";
import axios from "axios";
// import { history } from "../stores";

const webAuth = new auth0.WebAuth(constants.CONFIG);

// function removeHash() {
//     // eslint-disable-next-line no-restricted-globals
//     if (typeof window !== "undefined" && window.location.hash) {
//         history.replaceState(null, document.title, window.location.pathname + window.location.search);
//       }
// }

function setToken(val: string) {
  storage.setItem("accessToken", val);
}

function setExpiration(expireDate: Date) {
  storage.setItem("expireDate", expireDate);
}

function setProfile(val: auth0.Auth0UserProfile) {
  storage.setItem("profile", val);
}

function removeProfile() {
  storage.removeItem("profile");
}

function removeToken() {
  storage.removeItem("accessToken");
}

function calculateAndSetExpiration(expiresInSec: number): Date {
  const expireDate = new Date();
  expireDate.setSeconds(expireDate.getSeconds() + expiresInSec);
  setExpiration(expireDate);
  return expireDate;
}

export function loginAuth0(
  dispatch: Dispatch<actionTypes.LoginAction>,
  returnPath: string
) {
  dispatch({ type: TypeKeys.NAVIGATE_TO_LOGIN });
  try {
    // We must double encode the returnTo value here so that Auth0 passes back the query params correctly
    webAuth.authorize({
      redirectUri: `${
        constants.CONFIG.redirectUri
      }?returnTo=${encodeURIComponent(returnPath)}`,
    });
  } catch (error) {
    dispatch({ type: TypeKeys.NAVIGATE_TO_LOGIN_ERROR, error });
  }
}

export function logoutAuth0(dispatch: Dispatch<actionTypes.LogoutAction>) {
  dispatch({ type: TypeKeys.LOGOUT_REQUEST });
  removeToken();
  removeProfile();
  dispatch({ type: TypeKeys.LOGOUT_SUCCESS, profile: {}, accessToken: null });
}

export function handleAuthCallback(
  dispatch: Dispatch<actionTypes.LoginAction>
) {
  dispatch({ type: TypeKeys.DO_AUTHENTICATION });
  webAuth.parseHash(
    { hash: window.location.hash },
    (
      parseErr: auth0.Auth0Error | null,
      authData: auth0.Auth0DecodedHash | null
    ) => {
      if (parseErr) {
        dispatch({ type: TypeKeys.DO_AUTHENTICATION_ERROR, error: parseErr });
        window.location.href = "/";
        return;
      }

      if (authData === null || authData.accessToken === undefined) {
        return;
      }

      const accessToken = authData.accessToken as string;
      // removeHash();
      webAuth.client.userInfo(
        accessToken,
        (
          infoErr: auth0.Auth0Error | null,
          profile: any | auth0.Auth0UserProfile
        ) => {
          // TODO How can we make this keyFix work so that it can be dropped in any deako redux app?
          const keyFix = (k: any) =>
            k.replace(/^https:\/\/store.deako.com\//, "");
          const fixed = Object.assign(
            {},
            ...Object.keys(profile).map((key) => ({
              [keyFix(key)]: profile[key],
            }))
          );
          if (infoErr) {
            dispatch({
              type: TypeKeys.DO_AUTHENTICATION_ERROR,
              error: infoErr,
            });
          }
          setProfile(fixed);
          setToken(accessToken);
          const expireDate = calculateAndSetExpiration(
            authData.expiresIn as number
          );
          dispatch({
            type: TypeKeys.DO_AUTHENTICATION_SUCCESS,
            profile,
            accessToken,
            expireDate,
          });
        }
      );
    }
  );
}

export function requestRenewToken(): Promise<auth0.Auth0DecodedHash> {
  return new Promise((resolve, reject) => {
    webAuth.renewAuth(
      {
        usePostMessage: true,
        redirectUri: constants.TOKEN_RENEW_CALLBACK_URI,
      },
      (err: auth0.Auth0Error | null, authResult: auth0.Auth0DecodedHash) => {
        if (err || authResult == null) {
          reject(err);
        } else {
          resolve(authResult);
        }
      }
    );
  });
}

export async function renewTokenAuth0(
  dispatch: Dispatch<AuthAction>
): Promise<void> {
  let authData: auth0.Auth0DecodedHash;
  dispatch({ type: TypeKeys.RENEW_TOKEN });
  try {
    authData = await requestRenewToken();
  } catch (err) {
    logoutAuth0(dispatch);
    dispatch({ type: TypeKeys.RENEW_TOKEN_ERROR, error: err });
    return;
  }
  const freshToken = authData.accessToken as string;
  setToken(freshToken);
  const expireDate = calculateAndSetExpiration(authData.expiresIn as number);
  dispatch({
    type: TypeKeys.RENEW_TOKEN_SUCCESS,
    accessToken: freshToken,
    expireDate,
  });
}

function base64urlEncodeBrowser(arr: Uint8Array): string {
  return btoa(String.fromCharCode(...arr))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}
export function generateAuth0StyleStateClient() {
  const getRandom = (len: number) => {
    const arr = new Uint8Array(len);
    window.crypto.getRandomValues(arr);
    return base64urlEncodeBrowser(arr);
  };

  const header = getRandom(32);
  const tid = getRandom(24);
  const cid = getRandom(16);

  return `${header}logino3RpZNkg${tid}-jY2lk2SA${cid}`;
}

export function loginAlexa(
    dispatch: Dispatch<actionTypes.LoginAction>,
    returnPath: string
  ) {
    dispatch({ type: TypeKeys.NAVIGATE_TO_LOGIN });
  
    const state = generateAuth0StyleStateClient();
    const nonce = Math.random().toString(36).substring(2);
  
    sessionStorage.setItem("oauth_state", state);
    sessionStorage.setItem("oauth_nonce", nonce);
  
    const params = new URLSearchParams({
        client_id: constants.CONFIG.clientID || "",
        redirect_uri: `${constants.CONFIG.redirectUri}?returnTo=${encodeURIComponent(returnPath)}`,
        response_type: "code",
        scope: constants.CONFIG.scope,
        state,
        nonce,
        audience: constants.CONFIG.audience,
    });
  
    window.location.href = `https://${constants.CONFIG.domain}/oauth/authorize?${params.toString()}`;
  }

  export function logoutAlexa(dispatch: Dispatch<actionTypes.LogoutAction>) {
    dispatch({ type: TypeKeys.LOGOUT_REQUEST });
    removeToken();
    removeProfile();
    dispatch({ type: TypeKeys.LOGOUT_SUCCESS, profile: {}, accessToken: null });
}

function getHashParams(): { [key: string]: string } {
    if (typeof window === "undefined") return {};
    const hash = window.location.hash.substring(1);
    return hash.split("&").reduce((acc, part) => {
      const [key, val] = part.split("=");
      if (key && val) acc[key] = decodeURIComponent(val);
      return acc;
    }, {} as Record<string, string>);
  }

  const getUserInfo = async (
    accessToken: string,
    dispatch: Dispatch<actionTypes.LoginAction>
  ) => {
    try {
      const response = await axios.get("https://sso-api.deako.com/api/userinfo", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
  
      const profile = response.data;
  
      // Calculate expiration (set default if API doesn’t return one)
      const expiresInSec = 3600; // 1 hour default
      const expireDate = calculateAndSetExpiration(expiresInSec);
  
      dispatch({
        type: TypeKeys.DO_AUTHENTICATION_SUCCESS,
        profile,
        accessToken,
        expireDate,
      });
  
      return profile;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      dispatch({
        type: TypeKeys.DO_AUTHENTICATION_ERROR,
        error,
      });
    }
  };
  

  export async function handleAlexaCallback(dispatch: Dispatch<actionTypes.LoginAction>) {
    dispatch({ type: TypeKeys.DO_AUTHENTICATION });
  
    const params = getHashParams();
  
    if (!params.access_token) {
        dispatch({
            type: TypeKeys.DO_AUTHENTICATION_ERROR,
            error: {
              error: "invalid_token",
              errorDescription: "No access token found.",
            },
          });
      return;
    }
   const profile = await getUserInfo(params.access_token, dispatch);
  
    if( profile){
        setToken(params.access_token);
        setProfile(profile);
        calculateAndSetExpiration(Number(params.expires_in));
        // removeHash();
    }
    dispatch({
      type: TypeKeys.DO_AUTHENTICATION_SUCCESS,
      profile: profile, 
      accessToken: params.access_token,
      expireDate: calculateAndSetExpiration(Number(params.expires_in))
    });
  }
  

  export async function renewTokenAlexa(
    dispatch: Dispatch<actionTypes.TokenAction | actionTypes.LogoutAction>
  ): Promise<void> {
    dispatch({ type: TypeKeys.RENEW_TOKEN });
  
    try {
      const state = generateAuth0StyleStateClient();
      const nonce = Math.random().toString(36).substring(2);
  
      sessionStorage.setItem("oauth_state", state);
      sessionStorage.setItem("oauth_nonce", nonce);
  
      const params = new URLSearchParams({
        client_id: constants.CONFIG.clientID || "",
        redirect_uri: constants.CONFIG.redirectUri,
        response_type: "token id_token",
        scope: constants.CONFIG.scope,
        state,
        nonce,
        audience: constants.CONFIG.audience,
        prompt: "none",
      });
  
      window.location.href = `https://${constants.CONFIG.domain}/oauth/authorize?${params.toString()}`;
    } catch (error: any) {
      logoutAlexa(dispatch); 
      dispatch({ type: TypeKeys.RENEW_TOKEN_ERROR, error });
    }
  }
  
  

  function isTargetApp(): boolean {
    const targets = ["alexa", "adc", "googlehome", "smartthings"];
    const urlParams = new URLSearchParams(window.location.search);
      const appParam = urlParams.get("app");
    if (appParam && targets.includes(appParam.toLowerCase())) {
      return true;
    }
      const returnTo = urlParams.get("returnTo");
    if (returnTo) {
      const queryPart = returnTo.split("?")[1];
      if (queryPart) {
        const innerParams = new URLSearchParams(queryPart);
        const innerApp = innerParams.get("app");
        if (innerApp && targets.includes(innerApp.toLowerCase())) {
          return true;
        }
      }
    }
  
    return false;
  }
  

  export function login(dispatch: Dispatch<actionTypes.LoginAction>, returnPath: string) {
    return isTargetApp() ? loginAlexa(dispatch, returnPath) : loginAuth0(dispatch, returnPath);
  }
  export function logout(dispatch: Dispatch<actionTypes.LogoutAction>) {
    return isTargetApp() ? logoutAlexa(dispatch) : logoutAuth0(dispatch);
  }
  export function handleAuth0Callback(dispatch: Dispatch<actionTypes.LoginAction>) {
    return isTargetApp() ? handleAlexaCallback(dispatch) : handleAuthCallback(dispatch);
  }
  export function renewToken(dispatch: Dispatch<AuthAction>) {
    return isTargetApp() ? renewTokenAlexa(dispatch) : renewTokenAuth0(dispatch);
  }

  

export default {
  get accessToken(): string {
    return storage.getItem("accessToken");
  },
  get profile(): auth0.Auth0UserProfile {
    return storage.getItem("profile") || {};
  },
  get expireDate(): Date {
    return new Date(storage.getItem("expireDate"));
  },
  get isLoggedIn(): boolean {
    return (
      !!this.accessToken &&
      !!this.expireDate &&
      new Date().getTime() < this.expireDate.getTime()
    );
  },
};
